module.exports = __webpack_public_path__ + "static/media/Icon-arrow-white.1d0c41a6.png";